/* eslint-disable react/style-prop-object */
import React, {Component} from "react";
import {
  deleteProcess,
  getAllProcessStatus,
  getAllProcessType,
  getProcessBySearchBar
} from "../../services/RequestService";
import "./ProcessPage.css";
import ModalInsertProcess from "../../components/process/ModalInsertProcess";
import {Button, ButtonGroup, Col, Row} from "react-bootstrap";
import {Header, Loading, PageContainer, TableComponentWithPagination} from "../../genericComponents";
import {masks} from "../../utils";
import {withConfirm} from "../../genericComponents/ConfirmDialog";
import {alertActions} from "../../store/actions/AlertActions";
import {connect} from "react-redux";
import {getSessionJwt} from "../../utils/jwt";

export class TableCalendarPage extends Component {
  constructor(props) {
    super(props);

    this.state = {
      done: false,
      showModal: false,

      filterName: localStorage?.process_filterName || "",
      filterCpf: localStorage?.process_filterCpf || "",
      filterStatusId: localStorage?.process_filterStatusId || "",
      filterTypeId: localStorage?.process_filterTypeId || "",
      showModalInsertProcess: false,
      loading: true,

      list: [],
      totalItems: 0,
      fixedTotalItems: 0,
      totalPages: 0,
      page: parseInt(localStorage?.processPageNumber || '0'),
      decodedToken: {},
      processTypes: [],
      processStatuses: [],
    };
  }

  componentDidMount = () => {
    this.setState({loading: true, decodedToken: getSessionJwt()});
    this.getByFilter();
    this.getProcessTypes();
    this.getProcessStatuses();
  };

  getProcessTypes = () => {
    getAllProcessType().then((res) => {
      if (res.ok) {
        this.setState({processTypes: res.data});
      }
    });
  };

  getProcessStatuses = () => {
    getAllProcessStatus().then((res) => {
      if (res.ok) {
        this.setState({processStatuses: res.data});
      }
    });
  };

  getByFilter = () => {
    this.setState({loading: true}, () => {
      const {filterName, filterCpf, filterStatusId, filterTypeId, page, done} = this.state;
      getProcessBySearchBar({
        name: filterName,
        cpf: filterCpf,
        processStatusId: filterStatusId ? Number(filterStatusId) : null,
        processTypeId: filterTypeId ? Number(filterTypeId) : null,
        page,
        done,
      }).then(({ok, data}) => {
        if (ok)
          this.setState({
            list: data.content.map((item) => ({
              id: item.id,
              customerName: item.customerName ?? "",
              protocol: item.protocol ?? "",
              customerCPF: item.customerCPF ?? "",
              processStatusName: item.processStatusName ?? "",
              processTypeName: item.processTypeName ?? "",
              cellName: item.cellName ?? "",
              creatorCell: item.creatorCellName ?? "",
              actionsLength: item.actionsLength ?? "0",
              done: item.done,
              deliveryDate: item.deliveryDate,
            })).sort((a, b) => (b.id > a.id ? 1 : -1)),
            page: data.currentPage,
            totalPages: data.totalPages,
            fixedTotalItems: data.fixedTotalItems,
            loading: false,
            totalItems: data.total
          });
      });
    });
  };

  pagination = (pageNumber) => {
    this.setState({page: pageNumber}, () => {
      localStorage.processPageNumber = pageNumber;
      this.getByFilter();
    });
  };

  switchProcessDone = (done) => {
    this.setState({done, page: 0}, () => this.getByFilter());
    localStorage.processPageNumber = 0;
  };

  clearFilters = () => {
    ["filterName", "filterCpf", "filterStatusId", "filterTypeId"].forEach((k) =>
      localStorage.removeItem(`process_${k}`)
    );
    this.setState(
      {filterName: "", filterCpf: "", filterStatusId: "", filterTypeId: "", page: 0},
      this.getByFilter
    );
  };

  handleInputChange = (e) => {
    e.persist();
    const {name, value} = e.target;
    this.setState((state) => ({...state, [name]: value, page: 0}));
    localStorage[`process_${name}`] = value;
  };

  handleSelectChange = (e) => {
    e.persist();
    const {name, value} = e.target;
    localStorage[`process_${name}`] = value;
    this.setState((state) => ({...state, [name]: value, page: 0}), this.getByFilter);
  };

  handleSearch = (e) => {
    if (e.key === "Enter") {
      this.getByFilter();
    }
  };

  setShowModalInsertProcess = (showModalInsertProcess) => {
    this.setState((state) => ({...state, showModalInsertProcess}));
    if (!showModalInsertProcess) {
      this.componentDidMount();
    }
  };

  getDeadlineDays = (data) => {
    let nowDate = new Date().getTime();
    let deliveryDate = new Date(data.deliveryDate).getTime();

    let diffTime = deliveryDate - nowDate;
    let diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
    return diffDays;
  };

  getDateBackgroundColor = (data) => {
    let diffDays = this.getDeadlineDays(data);

    if (data.done) {
      return "process-success-color-border p-2 my-2 clickable";
    } else if (diffDays > 10) {
      return "process-warning-color-border p-2 my-2 clickable";
    } else if (diffDays >= 0) {
      return "process-attention-color-border p-2 my-2 clickable";
    } else if (diffDays < 0) {
      return "process-danger-color-border p-2 my-2 clickable";
    }
  };

  render() {
    const {
      filterName,
      filterCpf,
      filterStatusId,
      filterTypeId,
      showModalInsertProcess,
      loading,
      done,
      totalItems,
      totalPages,
      page,
      fixedTotalItems,
      list,
      processTypes,
      processStatuses,
      decodedToken
    } = this.state;
    return (
      <Loading loading={loading}>
        <Header
          active="Processos"
          logged
          buttons={[
            this.props.privileges?.processo?.create ? {
              icon: "fas fa-plus-circle",
              label: "Adicionar",
              onClick: () => this.setShowModalInsertProcess(true),
            } : null,
          ]}
        />

        <PageContainer fixedHeight className="p-3">
          <div className="card p-3 mb-3 flex-shrink-0">
            <Row>
              <Col xs={12} md={6} lg={3} className="mb-2">
                <label className="mb-1 font-weight-bold">Nome</label>
                <input
                  type="text"
                  className="form-control"
                  name="filterName"
                  placeholder="Nome do cliente"
                  value={filterName}
                  onChange={this.handleInputChange}
                  onKeyPress={this.handleSearch}
                />
              </Col>
              <Col xs={12} md={6} lg={3} className="mb-2">
                <label className="mb-1 font-weight-bold">CPF</label>
                <input
                  type="text"
                  className="form-control"
                  name="filterCpf"
                  placeholder="CPF do cliente"
                  value={filterCpf}
                  onChange={this.handleInputChange}
                  onKeyPress={this.handleSearch}
                />
              </Col>
              <Col xs={12} md={6} lg={3} className="mb-2">
                <label className="mb-1 font-weight-bold">Status do processo</label>
                <select
                  className="form-control"
                  name="filterStatusId"
                  value={filterStatusId}
                  onChange={this.handleSelectChange}
                >
                  <option value="">Todos</option>
                  {processStatuses.map((s) => (
                    <option key={s.id} value={s.id}>
                      {s.name}
                    </option>
                  ))}
                </select>
              </Col>
              <Col xs={12} md={6} lg={3} className="mb-2">
                <label className="mb-1 font-weight-bold">Tipo da tese</label>
                <select
                  className="form-control"
                  name="filterTypeId"
                  value={filterTypeId}
                  onChange={this.handleSelectChange}
                >
                  <option value="">Todos</option>
                  {processTypes.map((t) => (
                    <option key={t.id} value={t.id}>
                      {t.name}
                    </option>
                  ))}
                </select>
              </Col>
            </Row>
            <Row className="align-items-end mt-2">
              <Col xs={12} md={6} lg={4} className="mb-2 mb-md-0">
                <label className="mb-1 font-weight-bold">Situação</label>
                <ButtonGroup className="w-100">
                  <Button
                    variant={!done ? "success" : "outline-success"}
                    onClick={() => {
                      if (done) this.switchProcessDone(false);
                    }}
                  >
                    <i className="fas fa-folder-open mr-2" />
                    Abertos
                  </Button>
                  <Button
                    variant={done ? "danger" : "outline-danger"}
                    onClick={() => {
                      if (!done) this.switchProcessDone(true);
                    }}
                  >
                    <i className="fas fa-folder mr-2" />
                    Fechados
                  </Button>
                </ButtonGroup>
              </Col>
              <Col xs={12} md={6} lg={8} className="text-right">
                <Button
                  variant="outline-secondary"
                  className="mr-2"
                  onClick={this.clearFilters}
                >
                  Limpar
                </Button>
                <Button variant="primary" onClick={() => this.getByFilter()}>
                  <i className="fas fa-search mr-2" />
                  Filtrar
                </Button>
              </Col>
            </Row>
          </div>

          <TableComponentWithPagination
            loading={loading}
            countLabel="processos"
            countLabelSingular="processo"
            startSorted="id"
            header={[
              {label: "#", sortProperty: "id"},
              {label: "Cliente", sortProperty: "customerName"},
              {label: "Protocolo", sortProperty: "protocol"},
              {label: "CPF", sortProperty: "customerCPF"},
              {label: "Status do processo", sortProperty: "processStatusName",},
              {label: "Tipo de tese", sortProperty: "processTypeName"},
              {label: "Célula Responsavel", sortProperty: "cellName"},
              {label: "Célula Criadora", sortProperty: "creatorCell"},
              decodedToken.is_admin && {label: "Remover"},
            ]}
            totalItems={totalItems}
            fixedTotalItems={fixedTotalItems}
            totalPages={totalPages}
            page={page}
            list={list}
            forEach={(item) => [
              {label: item.id},
              {label: item.customerName},
              {label: item.protocol},
              {label: item.customerCPF ? masks.CPF(item.customerCPF) : item.customerCPF},
              {label: item.processStatusName},
              {label: item.processTypeName},
              {label: item.cellName},
              {label: item.creatorCell},
              decodedToken.is_admin && {
                onClick: async () => {
                  const confirmed = await this.props.confirm('Deseja realmente remover o processo?', {
                    title: 'Confirma?',
                    btnConfirm: 'Sim',
                    btnCancel: 'Não',
                  });
                  if (!confirmed) return;

                  const resp = await deleteProcess(item.id);
                  if (resp.ok) {
                    this.getByFilter();
                    this.props.onAddAlert('Processo removido com sucesso!', "success", true);
                  } else {
                    this.props.onAddAlert('Erro ao remover processo!', "danger", true);
                  }
                },
                label: (<div className="text-center"><i className="fas fa-trash-alt is-required"></i></div>),
              },
            ]}
            setItemClassName={this.getDateBackgroundColor}
            onItemClick={(item) => this.props.history.push("/processo/" + item.id + "/processos")}
            onChangePage={this.pagination}
          />
        </PageContainer>
        {showModalInsertProcess && (
          <ModalInsertProcess
            show={showModalInsertProcess}
            onHide={() => this.setShowModalInsertProcess(false)}
            processTypes={processTypes}
          />
        )}
      </Loading>
    );
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    onAddAlert: (text, alertType, alertPriority) =>
      dispatch(alertActions.addAlert(text, alertType, alertPriority)),
  };
};

export default withConfirm(connect(null, mapDispatchToProps)(TableCalendarPage));
